
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';



import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'apm-invalid-link-page',
  imports: [RouterLink, FaIconComponent],
  templateUrl: './invalid-link-page.component.html',
  styleUrl: './invalid-link-page.component.scss',
})
export class InvalidLinkPageComponent {}
